var sequence = function(path, elements, startWith) {
    startWith = startWith || 0;
    var array = [];
    for (var i = 0; i < elements; i++) {
        array.push(path.$(i + startWith));
    }
    return array;
};

module.exports = {
    howler: [
        'res/sounds/win',
        'res/sounds/freegames_start',
        'res/sounds/freegames_music',
        'res/sounds/freegames_end',
        'res/sounds/click',
        'res/sounds/scatter_win',
        'res/sounds/scatters_win_freegames',
        'res/sounds/bet-up',
        'res/sounds/bet-down',
        'res/sounds/credits',
        'res/sounds/help_ambient'
    ]
    .concat(sequence('res/sounds/lines/lines_%d', 5))
    .concat(sequence('res/sounds/fill_symbol_%d', 2))
    .concat(sequence('res/sounds/scatters/scatter_%d', 5))
    .concat(sequence('res/sounds/line_wins/line_%d', 10)),
    pixi: [
        'res/maingame/background.jpg',
        'res/freegames/background.jpg',
        'res/freegames/press_start.png',
        'res/freegames/press_finish.png',
        'res/freegames/table_start.png',
        'res/freegames/table_finish.png',
        'res/freegames/freegames_count.png',
        'res/poster.png',

        'res/help/page_0.jpg',

        'res/maingame/symbols.json',

        'res/logo.png',

        'res/frame.json',

        'res/billet.png',

        'res/tables/table_big.png',
        'res/tables/table_small.png',
        'res/tables/i-maxi.png',
        'res/tables/i-mini.png',
        'res/tables/buttons/maximize.png',
        'res/tables/buttons/minimize.png',
        'res/tables/buttons/mute_on.png',
        'res/tables/buttons/mute_off.png',

        'res/fonts/help_font.xml',
        'res/fonts/freegame_font.xml',
        'res/fonts/freegame_counter_font.xml'



    ]
};



//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 65
// module chunks = 0